import type { RequestSchema } from 'app/developer-v3/platformSchema/request';

export const getRequestDescription = (request?: RequestSchema) => {
  if (request && request.source) {
    return '(Code)';
  }
  if (request && request.url) {
    return request.url;
  }
  return 'N/A';
};
